import { NAV_ACTIVE_CLASSES, NAV_ROW_HEIGHT } from './navConfig';

/**
 * Outer-geometry classes for a top-level nav row: fixed height, the always-present
 * left rail, and exactly ONE text-color state (active indigo family OR the caller's
 * inactive base — never both, so they can't fight on CSS source order).
 * Applied to the row's OWN element (button / NavLink / div), never a wrapping node.
 */
export function sideNavRowShellClasses(opts: {
  active?: boolean;
  inactiveText?: string;
}): string {
  const { active = false, inactiveText = 'text-sidebar-foreground/80' } = opts;
  const base = `${NAV_ROW_HEIGHT} flex items-center border-l-2`;
  return active
    ? `${base} ${NAV_ACTIVE_CLASSES.textAndBorder}`
    : `${base} border-transparent ${inactiveText}`;
}
